<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 29 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.752 2.94302H10.7617V2.37662H9.26425C9.55731 2.05949 9.81452 1.70412 10.0267 1.31455L8.53444 0.501812C7.90465 1.65824 6.69634 2.37662 5.38103 2.37662C4.06413 2.37662 2.85508 1.65694 2.22575 0.498413L0.732647 1.30951C0.945332 1.70106 1.2035 2.05813 1.4978 2.37662H0V3.22623C0 3.97581 0.60985 4.5856 1.35938 4.5856H1.98911L2.73325 8.67851C2.90476 9.62169 3.72508 10.3063 4.68373 10.3063H5.34064C6.27674 11.512 7.44683 12.5305 8.77312 13.2904L9.48175 20.5016H12.0656L13.3453 14.7709C13.7587 14.8152 14.1736 14.8376 14.5858 14.8376H22.1925L22.5832 16.0718L22.0348 20.5016H24.7385L27.3008 12.9231V15.6872H29V7.19107C29 4.8487 27.0943 2.94302 24.752 2.94302ZM6.35672 8.37452C6.3322 8.50927 6.21501 8.60708 6.07805 8.60708H4.68367C4.54671 8.60708 4.42952 8.50927 4.405 8.37458L3.62353 4.07583H7.13825L6.35672 8.37452ZM27.3008 7.61774L24.2105 16.7581L24.3152 15.9125L22.3335 9.65341L20.7134 10.1663L21.6544 13.1384H14.5858C14.004 13.1384 13.4152 13.0862 12.8358 12.9832L12.0352 12.8409L10.9249 17.8129L10.3753 12.2195L9.96711 12.007C8.9465 11.4755 8.02382 10.7681 7.24445 9.92664C7.64473 9.63523 7.93433 9.19598 8.02841 8.67857L8.7623 4.64224H9.01775C9.13534 6.17884 10.1997 7.45473 11.6272 7.88503C12.1124 8.03128 12.5167 8.37639 12.7031 8.84752C13.0934 9.83358 14.0564 10.5329 15.1797 10.5329C16.2923 10.5329 17.2477 9.84678 17.645 8.87545C17.8436 8.39009 18.259 8.03252 18.7631 7.88798C20.2439 7.46334 21.3725 6.19697 21.5959 4.64224H24.752C26.1596 4.64224 27.3008 5.78338 27.3008 7.19107V7.61774Z"
      fill="#495057"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconBovine',
  props: {
    width: {
      type: Number,
      default: 25,
    },
    height: {
      type: Number,
      default: 17,
    },
  },
};
</script>

<style scoped>
</style>